import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';


@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[formControlFloat]',
    // tslint:disable-next-line: use-host-property-decorator
    host: {
        '(blur)': 'onBlur()'
    }
})

export class InputFloatDirective implements OnInit {

    constructor(private _el: ElementRef, private renderer: Renderer2) { }

    elem: any = this._el.nativeElement;

    onBlur() {

        this.elem.value ?
            this.renderer.addClass(this.elem, 'form-control--active')
            :
            this.renderer.removeClass(this.elem, 'form-control--active');
    }

    ngOnInit(): void {
        if (this.elem.value) {
            // Add class
            this.renderer.addClass(this.elem, 'form-control--active');
        }
    }
}
